import {DataStore, Predicates, SortDirection} from '@aws-amplify/datastore';
import {ReturnToApplication} from 'models';

import {I18n} from '@aws-amplify/core';

import config from 'config';

export const isAllowedHostname = (hostname) => {
    let out = false;

    config.allowedReturnToDomains.forEach((domainName) => {
        if (hostname.indexOf(domainName) !== -1) {
            out = true;
        }
    });

    return out;
};

export const fetchRecords = async () => {
    try {
        return DataStore.query(ReturnToApplication, Predicates.ALL, {
            sort: (s) => s.position(SortDirection.ASCENDING),
        });
    } catch (e) {
        console.debug(e);
    }
};

export const fetch = async (recordId) => {
    return DataStore.query(ReturnToApplication, recordId);
};

export const add = async (payload) => {
    if (!isAllowedHostname(payload.hostname)) {
        throw new Error('Operation is not allowed');
    }

    // UPDATE OTHER ITEMS
    const otherItems = await DataStore.query(ReturnToApplication, (c) =>
        c.origin('ne', payload.origin)
    );
    const promises = [];
    otherItems.forEach((otherItem) => {
        const updatedItem = ReturnToApplication.copyOf(otherItem, (updated) => {
            updated.position = 2;
            updated.updatedAt = new Date().toISOString();
        });
        promises.push(DataStore.save(updatedItem));
    });
    await Promise.all(promises);

    // CHECK FOR EXISTING ITEM AND UPDATE THE POSITION TO 1
    const existingItems = await DataStore.query(ReturnToApplication, (c) =>
        c.origin('eq', payload.origin)
    );

    if (Array.isArray(existingItems) && existingItems.length > 0) {
        const existingItem = existingItems.shift();
        const updated = ReturnToApplication.copyOf(existingItem, (updated) => {
            updated.position = 1;
            updated.updatedAt = new Date().toISOString();
        });
        return DataStore.save(updated);
    } else {
        payload.createdAt = new Date().toISOString();
        payload.position = 1;
        return DataStore.save(new ReturnToApplication({...payload}));
    }
};

export const update = async (recordId, record) => {
    const original = await DataStore.query(ReturnToApplication, recordId);

    const updated = ReturnToApplication.copyOf(original, (updated) => {
        updated.host = record.host;
        updated.hostname = record.hostname;
        updated.origin = record.origin;
        updated.pathname = record.pathname;
        updated.port = record.port;
        updated.protocol = record.protocol;
        updated.position = record.position;
        updated.updatedAt = new Date().toISOString();
    });

    I18n.setLanguage(record.language);

    return DataStore.save(updated);
};

export const deleteRecord = async (recordId) => {
    const original = await DataStore.query(ReturnToApplication, recordId);
    return DataStore.delete(original);
};

export const deleteAllRecords = async () => {
    return DataStore.delete(ReturnToApplication, Predicates.ALL);
};

export const swap = async () => {
    const applications = await fetchRecords();
    const promises = [];
    applications.forEach((application) => {
        const updated = ReturnToApplication.copyOf(application, (updated) => {
            if (application.position === 1) {
                updated.position = 2;
            } else {
                updated.position = 1;
            }
            updated.updatedAt = new Date().toISOString();
        });
        promises.push(DataStore.save(updated));
    });

    await Promise.all(promises);
    return fetchRecords();
};
